/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Active_OnlyInputs */

const cs_demands_active_only = /** @type {(inputs: Demands_Active_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen aktivní`)
};

const en_demands_active_only = /** @type {(inputs: Demands_Active_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active only`)
};

/**
* | output |
* | --- |
* | "Active only" |
*
* @param {Demands_Active_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_active_only = /** @type {((inputs?: Demands_Active_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Active_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_active_only(inputs)
	return cs_demands_active_only(inputs)
});